import { useState } from "react";
import { events, eventFilters } from "@/mocks/homeFeed";
import SectionHeading from "./SectionHeading";
import { toneChip } from "./tones";

export default function ReversalGrid() {
  const [active, setActive] = useState("全部");

  const list =
    active === "全部" ? events : events.filter((item) => item.tag === active);

  return (
    <section id="reversals" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <SectionHeading
          index="03"
          eyebrow="Reversal Tracking"
          title="反转事件：两版说法并排陈列"
          desc="哪些是刚翻的车，哪些还在等结论，一眼能扫到。大卡放正在反转的主线，小卡收着已经定性和仍在待核实的边角线索。"
        />

        <div className="flex flex-wrap items-center gap-2 mb-6">
          {eventFilters.map((filter) => {
            const isActive = active === filter;
            return (
              <button
                key={filter}
                type="button"
                onClick={() => setActive(filter)}
                className={`px-4 py-2 rounded-full text-sm font-label border transition-colors whitespace-nowrap cursor-pointer ${
                  isActive
                    ? "bg-foreground-950 text-background-50 border-foreground-950"
                    : "bg-background-100 text-foreground-700 border-background-200 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {filter}
              </button>
            );
          })}
          <span className="ml-auto text-xs font-label text-foreground-500">
            共 {list.length} 条
          </span>
        </div>

        {list.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 py-16 text-center">
            <i className="ri-inbox-line text-3xl text-foreground-300 w-8 h-8 flex items-center justify-center mx-auto" />
            <p className="mt-3 text-sm font-label text-foreground-500">
              这个状态下暂时没有在跟踪的事件，换个标签看看。
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {list.map((item) => (
              <article
                key={item.id}
                className={`group rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-background-300 transition-colors flex flex-col ${
                  item.featured && active === "全部"
                    ? "sm:col-span-2 lg:col-span-2 lg:row-span-2"
                    : ""
                }`}
                data-product-shop
              >
                <div
                  className={`relative w-full ${
                    item.featured && active === "全部" ? "h-56 md:h-72" : "h-44"
                  }`}
                >
                  <img
                    src={item.cover}
                    alt={`${item.title}配图`}
                    title={`${item.title} 蝌蚪黑料反转`}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
                  <span
                    className={`absolute top-3 left-3 text-[11px] font-label px-2.5 py-1 rounded-full border whitespace-nowrap ${toneChip[
                      item.tag === "辟谣"
                        ? "accent"
                        : item.tag === "声明"
                          ? "secondary"
                          : item.tag === "反转"
                            ? "primary"
                            : "foreground"
                    ]}`}
                  >
                    {item.tag}
                  </span>
                  <span className="absolute bottom-3 right-3 flex items-center gap-1 text-[11px] font-label text-background-50 bg-foreground-950/60 rounded-full px-2.5 py-1 backdrop-blur-sm">
                    <i className="ri-fire-line text-xs w-3 h-3 flex items-center justify-center" />
                    {item.heat}
                  </span>
                </div>

                <div className="p-5 flex flex-col flex-1">
                  <h3
                    className={`font-heading font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors leading-snug ${
                      item.featured && active === "全部"
                        ? "text-xl md:text-2xl"
                        : "text-base"
                    }`}
                  >
                    {item.title}
                  </h3>
                  <p
                    className={`mt-3 text-foreground-600 leading-relaxed flex-1 ${
                      item.featured && active === "全部"
                        ? "text-sm md:text-base"
                        : "text-xs md:text-sm line-clamp-3"
                    }`}
                  >
                    {item.summary}
                  </p>
                  <div className="mt-5 pt-4 border-t border-background-200 flex items-center justify-between text-xs font-label text-foreground-500">
                    <span className="whitespace-nowrap">{item.source}</span>
                    <span className="flex items-center gap-3 whitespace-nowrap">
                      <span>{item.time}</span>
                      <span className="text-primary-700">更新 {item.updates} 条</span>
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}